import React from 'react';

interface SocialProps {
    icon: React.ReactNode;
    href: string;
    type?: string;
}

const Social: React.FC<SocialProps> = ({ icon, href, type }) => {
    if(type === "light") {
        return (
            <a href={href} target="_blank" className='flex items-center justify-center rounded-full w-[40px] h-[40px]'>
                {icon}
            </a>
        )
    } else {
        return (
            <a href={href} target="_blank" className='flex items-center justify-center rounded-full bg-yellow-100 w-12 h-12'>
                {icon}
            </a>
        )
    }
    
}

export default Social